// extracted by mini-css-extract-plugin
module.exports = {"container":"MD_gfuc79TgwpKd4uq1OK","inner":"_1TWyME7GA4n2dUnP5-CMZS","video":"IDasYXM-NvTLttgh80ItG","videoWrapper":"Y1_3SleEfovEGFWPHrM_Z","cover":"_16EN3f2l7a6_sV1QJnssfw"};